// base class for all the inidivdual data providers. includes default
// implementation of the "many" functions that just repeatedly call
// the "one" functions, etc.
//
class BaseDataProvider {
  constructor(client) {
    //console.log("BaseDataProvider.constructor()");
    this.client = client;
  }

  async getMany(resource, params) {
    console.log(
      "BasenDataProvider.getMany(" +
        resource +
        "," +
        JSON.stringify(params) +
        ")"
    );
    let data = [];
    for (let i = 0; i < params.ids.length; i++) {
      const one = await this.getOne(resource, { id: params.ids[i] });
      data.push(one.data);
    }
    return { data: data };
  }
}

export default BaseDataProvider;
